import { Suspense, useState } from 'react'
import {
    Await,
    defer,
    useLoaderData,
    useNavigate,
    Link
} from 'react-router-dom'
import { sharelink } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Link.module.scss'

import { useEffect } from 'react'

export const loader = async () => {
    return defer({ sharelink: sharelink() })
}

export default function VirtualTour() {
    const pageName = 'پیوندهای مفید'
    Title(pageName)
    const [loaderData, setLoaderData] = useState(useLoaderData())
const navigate = useNavigate()
    useEffect(() => {
        document.querySelector('header span').innerText = pageName
        window.scrollTo(0, 0)
    }, [])

    return (
        <section className={styles.link}>
            <div className='__frame' data-width={`large`}>
            <Link to={`../`} className='button' style={{maxWidth:'100px', margin: '1rem auto'}}>بازگشت</Link>
                <div className={styles.emam}>

                <figure>
                        <img src={require('../../src/images/emam-khomenie.png')}/>
                    </figure>
                    
                    <figure>
                        <img src={require('../../src/images/slogan.png')}/>
                    </figure>
                    
                    <figure>
                        <img src={require('../../src/images/emam-khamenie.png')}/>
                    </figure>
                </div>
                <div className='grid grid--fit grid--gap-1' style={{ '--data-width': '300px', 'width': '100%' }}>
                    <Suspense fallback={<LoadingSpinner />}>
                        <Await
                            resolve={loaderData.sharelink}
                            errorElement={<p>⚠️</p>}>
                            {(data) => {
                                console.log(data)
                                return (
                                    <>
                                        {
                                            data.map((item) => {
                                                return <>
                                                    <div className={styles.item}>
                                                        <div className={`${styles.itemBody} d-flex align-items-center`} style={{ columnGap: '1rem' }}>
                                                            <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14.75 15.2H7.6C5.5 15.2 3.70833 14.4583 2.225 12.975C0.741667 11.4917 0 9.7 0 7.6C0 5.5 0.741667 3.70833 2.225 2.225C3.70833 0.741667 5.5 0 7.6 0H14.75V1.1H7.6C5.8 1.1 4.26667 1.73333 3 3C1.73333 4.26667 1.1 5.8 1.1 7.6C1.1 9.4 1.73333 10.9333 3 12.2C4.26667 13.4667 5.8 14.1 7.6 14.1H14.75V15.2ZM11 8.15V7.05H24.25V8.15H11ZM20.45 15.2V14.1H27.6C29.4 14.1 30.9333 13.4667 32.2 12.2C33.4667 10.9333 34.1 9.4 34.1 7.6C34.1 5.8 33.4667 4.26667 32.2 3C30.9333 1.73333 29.4 1.1 27.6 1.1H20.45V0H27.6C29.7 0 31.4917 0.741667 32.975 2.225C34.4583 3.70833 35.2 5.5 35.2 7.6C35.2 9.7 34.4583 11.4917 32.975 12.975C31.4917 14.4583 29.7 15.2 27.6 15.2H20.45Z" />
                                                            </svg>
                                                            <a target={'_blank'} href={`${item.url}`}>{item.name}</a>
                                                            <span dir='ltr'>{item.url}</span>
                                                        </div>
                                                    </div>
                                                </>

                                            })
                                        }
                                    </>
                                )

                            }}
                        </Await>
                    </Suspense>
                </div>
                <Link to={`../`} className='button' style={{maxWidth:'100px', margin: '1rem auto'}}>بازگشت</Link>
            </div>
            
        </section>
    )
}